/**
 * `<DeleteContactDialog>` — soft-delete confirm. High-friction tier per
 * NFR-Design § 2 / NFR-SEC-16: the user types the contact's user id
 * before the destructive confirm button enables.
 */

import { useTranslation } from "react-i18next";

import { TypedConfirmDialog } from "../common/TypedConfirmDialog";

export interface DeleteContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contactUserId: string;
  contactDisplayName: string | null;
  busy?: boolean;
  onConfirm: () => void;
}

export function DeleteContactDialog({
  open,
  onOpenChange,
  contactUserId,
  contactDisplayName,
  busy = false,
  onConfirm,
}: DeleteContactDialogProps) {
  const { t } = useTranslation("contacts");
  const visibleName = contactDisplayName ?? contactUserId;
  return (
    <TypedConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t("delete.title")}
      body={t("delete.body", { name: visibleName })}
      confirmationPhrase={contactUserId}
      inputLabel={t("delete.typedLabel", { phrase: contactUserId })}
      confirmLabel={t("delete.confirm")}
      destructive
      busy={busy}
      onConfirm={onConfirm}
      testId="delete-contact-dialog"
    />
  );
}
